import { Component, computed, inject, viewChild } from '@angular/core';
import { MenuItem } from 'primeng/api';
import { MenuModule } from 'primeng/menu';
import { Menu } from 'primeng/menu';

import { AuthService } from '@core/services/auth';

@Component({
  selector: 'yt-user-menu',
  imports: [MenuModule],
  templateUrl: './user-menu.html',
  styleUrl: './user-menu.scss'
})
export class UserMenu {
  private readonly authAPIs = inject(AuthService);
  private readonly menu = viewChild<Menu>('menu');

  readonly userData = this.authAPIs.userData;

  readonly initials = computed(() => {
    const data = this.userData();
    if (!data?.userData) return '?';
    const name: string = data.userData.name || data.userData.preferred_username || '';
    const parts = name.split(' ').filter(Boolean);
    if (parts.length >= 2) {
      return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
    }
    return name.substring(0, 2).toUpperCase() || '?';
  });

  readonly displayName = computed(() => {
    const data = this.userData();
    if (!data?.userData) return '';
    const name: string = data.userData.name || data.userData.preferred_username || '';
    const parts = name.split(' ');
    if (parts.length >= 2) {
      return parts[0] + ' ' + parts[parts.length - 1][0] + '.';
    }
    return name;
  });

  readonly menuItems: MenuItem[] = [
    {
      label: 'Logout',
      icon: 'pi pi-sign-out',
      command: () => this.authAPIs.logout()
    }
  ];

  toggleMenu(event: Event): void {
    this.menu()?.toggle(event);
  }
}
